import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isIOS } from 'react-device-detect';
import randomstring from 'uuid/v4';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import BluetoothIcon from '@material-ui/icons/Bluetooth';
import SettingsBluetooth from '@material-ui/icons/SettingsBluetooth';

import Bluetooth from '../../../inputs/Bluetooth';
import { NumPad } from '../../../inputs/NumPad';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/api.form.actions';
import * as actionsBluetooth from '../../../../actions/bluetooth.actions';

import { TypeTempIcon, EditIcon, HandIcon } from '../../../../images/icons/WrapSvg';

import Task from './Task';

// eslint-disable-next-line
import style from './_styles.css';

const isOutRange = (range, valor) => {
    let result = false;
    if (range && valor) {
        const reference = parseFloat(valor);
        if (range.inferior && range.limiteinferior) {
            result = result || reference < parseFloat(range.inferior);
        } else if (range.inferior) {
            result = result || reference <= parseFloat(range.inferior);
        }
        if (range.superior && range.limitesuperior) {
            result = result || reference > parseFloat(range.superior);
        } else if (range.superior) {
            result = result || reference >= parseFloat(range.superior);
        }
    }
    return result;
};

class Temperature extends React.Component {
    state = {
        valor: '',
        temp: undefined,
        comentario: '',
        point: 0,
        correction: 0,
        message: undefined,
        intervalId: undefined,
        manually: false,
        read: false,
        invalid: isIOS || !(navigator && navigator.bluetooth),
        metadatos: {},
    };

    static getDerivedStateFromProps(props, state) {
        const { data, parentDeactivated } = props;
        if (data !== state.data || parentDeactivated !== state.parentDeactivated) {
            state.valor = data.valor ? parseInt(data.valor, 10) : undefined;
            state.desactivado = data.desactivado;
            state.metadatos = data.metadatos ? data.metadatos : {};
            state.data = data;
            state.comentario = data.comentario ? data.comentario : '';
            state.parentDeactivated = parentDeactivated;
            return state;
        }
        return null;
    }

    handleEdit = (event) => {
        if (this.state.read) this.props.setBluetoothUsed(false);
        this.setState({ manually: !this.state.manually, read: false });
    };

    handleClick = (event) => {
        const { data, intl, editable, bluetooth } = this.props;
        const { read, temp, manually, invalid } = this.state;

        if (editable && !data.disabled && !manually) {
            if (invalid) {
                const intervalId = setInterval(this.timer, 5000);
                this.setState({
                    intervalId: intervalId,
                    message: intl.formatMessage({ id: 'bluetooth_ios_warning' }),
                    manually: !this.state.manually,
                    read: false,
                });
            } else if (!manually) {
                if (read && temp) {
                    const { comentario } = this.state;
                    const { codigo } = data;
                    const metadatos = { bluetooth: true };
                    this.props.setValue(codigo, temp, comentario, false, metadatos);
                    this.props.setBluetoothUsed(false);
                    this.setState({ read: false, valor: temp, metadatos: metadatos });
                } else if (read) {
                    this.props.setBluetoothUsed(false);
                    this.setState({ read: false });
                } else if (!bluetooth && !read) {
                    this.props.setBluetoothUsed(true);
                    this.setState({ read: true });
                } else if (bluetooth) {
                    const intervalId = setInterval(this.timer, 5000);
                    this.setState({
                        intervalId: intervalId,
                        message: intl.formatMessage({ id: 'bluetooth_in_use_warning' }),
                    });
                }
            }
        }
    };

    handleComment = (name) => (event) => {
        const comentario = event.target.value;
        const { valor, metadatos } = this.state;
        this.props.setValue(name, valor, comentario, false, metadatos);
        this.setState({ comentario: comentario });
    };

    handleUpdate = (valor) => {
        this.setState({ temp: valor });
    };

    handleCloseNumPad = (valor) => {
        const { data } = this.props;
        const { comentario } = this.state;
        const metadatos = { manually: true };
        this.props.setValue(data.codigo, valor, comentario, false, metadatos);
        this.setState({ read: false, valor: valor, metadatos: metadatos, manually: false });
    };

    handleDeactive = (data, checked) => {
        this.props.setValue(data.codigo, undefined, '', checked, {});
        this.setState({ desactivado: checked, valor: undefined });
    };

    component = (name, intl, catalog, disabled) => {
        if (disabled) {
            return (
                <span className="barlow_regular_textwrap c_slate text_align_left padding_borders_text">
                    {this.state.comentario}
                </span>
            );
        } else if (!catalog) {
            return (
                <TextField
                    fullWidth
                    name={name}
                    id={name}
                    label={intl.formatMessage({ id: 'form_field_comment' })}
                    value={this.state.comentario}
                    onChange={this.handleComment(name)}
                />
            );
        } else {
            const info = this.props.instance.catalogos[catalog];
            return (
                <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                    <InputLabel htmlFor="age-native-simple">
                        {intl.formatMessage({ id: 'options_field_label' })}
                    </InputLabel>
                    <Select
                        native
                        value={this.state.comentario}
                        onChange={this.handleComment(name)}
                        inputProps={{ name: name, id: name }}
                    >
                        <option key={randomstring()} value={undefined} />
                        {info &&
                            info.valores &&
                            info.valores.length > 0 &&
                            info.valores.map((cat) => {
                                return (
                                    <option key={randomstring()} value={cat.id}>
                                        {cat.valor}
                                    </option>
                                );
                            })}
                    </Select>
                </FormControl>
            );
        }
    };

    column = () => {
        const { data } = this.props;
        const { valor, manually, read } = this.state;
        const out = isOutRange(data.alertable, valor);
        return (
            <div
                className={
                    'flex_fixed_column_88 display_flex elements_center hand ' +
                    (read
                        ? 'bg_golden_yellow'
                        : valor
                        ? out
                            ? 'bg_lipstick'
                            : 'bg_pea'
                        : manually
                        ? 'bg_bluish_25'
                        : 'bg_bluish')
                }
                onClick={this.handleClick}
            >
                {!valor && !read && !manually && (
                    <div className="align_center bg_bluish text_align_center">
                        <SettingsBluetooth className="c_white" />
                    </div>
                )}
                {manually && <NumPad value={valor} onClose={this.handleCloseNumPad} />}
                {!manually && read && <Bluetooth onChange={this.handleUpdate} />}
                {!manually && !read && valor && (
                    <div className={'barlow_semibold c_white center '}>
                        {valor && `${valor} ºC`}
                    </div>
                )}
            </div>
        );
    };

    render() {
        const { last, editable, intl } = this.props;
        const { data, valor, desactivado, parentDeactivated, metadatos } = this.state;

        const icons = [];

        if (metadatos && valor && metadatos.bluetooth) {
            icons.push(
                <div key={randomstring()} className="margin_left_12 c_bluish">
                    <BluetoothIcon />
                </div>,
            );
        }
        if (metadatos && valor && !metadatos.bluetooth) {
            icons.push(
                <div key={randomstring()} className="margin_left_12 c_bluish">
                    <HandIcon />
                </div>,
            );
        }

        if (editable && !desactivado && !data.disabled && !data.censurado && (!data.modoTest || !valor)) {
            icons.push(
                <div key={randomstring()} className="margin_left_12 hand c_bluish">
                    <EditIcon onClick={this.handleEdit} />
                </div>,
            );
        }

        return (
            <Task
                key={data.codigo}
                data={data}
                desactivado={desactivado}
                red={isOutRange(data.alertable, valor)}
                value={valor}
                icon={<TypeTempIcon color="primary" />}
                icons={icons}
                text={'type_label_real'}
                column={this.column()}
                last={last}
                editable={editable}
                component={this.component(
                    data.codigo,
                    intl,
                    data.catalogo,
                    !editable || data.disabled,
                )}
                parentDeactivated={parentDeactivated}
                onDeactive={this.handleDeactive}
            />
        );
    }
}

Temperature.propTypes = {
    instance: PropTypes.object.isRequired,
    instance_changes: PropTypes.array.isRequired,
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        instance: state.instance,
        instance_changes: state.instance_changes,
        bluetooth: state.bluetooth,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions, actionsBluetooth), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectIntl(Temperature));



// WEBPACK FOOTER //
// ./src/components/complex/forms/types/Bluetooth.js